import { useNavigate } from "react-router-dom";
import trans from "../utils";
import { useSelector } from "react-redux";

const AccessDenied = () => {
	const navigate = useNavigate();
	const user = useSelector((state) => state.users.auth);
	const handleGoBack = () => {
		if (user?.permissions.find((perm) => perm.moduleKey === "DASHBOARD")) {
			navigate("/dashboard");
		} else {
			navigate("/setup/account");
		}
	};

	return (
		<div className="AccessDenied">
			<img
				src={`${process.env.PUBLIC_URL}/assets/access.svg`}
				alt="access"
				className="mb-3"
			/>
			<h1 className="AccessDenied-title">{trans("Access Denied")}</h1>
			<p className="AccessDenied-text">
				{trans("Sorry, you don't have permission to access this page.")}
			</p>
			<button className="AccessDenied-btn" onClick={handleGoBack}>
				{trans("Back to Home")}
			</button>
		</div>
	);
};

export default AccessDenied;
